import React, { useDispatch, useEffect, useState } from "reactn";

export const useJoinWs = () => {
	const joinChannel = useDispatch("joinChannel");
	const leaveChannel = useDispatch("leaveChannel");
	const requestOffice = useDispatch("requestOffice");
	const requestLines = useDispatch("requestLines");
	const [officeSlug, setOfficeSlug] = useState(false);

	const join = (officeSlug) => {
		setOfficeSlug(officeSlug);
	};

	useEffect(() => {
		if (officeSlug) joinChannel({ officeSlug });
		return () => {
			leaveChannel({ officeSlug });
		};
	}, [officeSlug, joinChannel, leaveChannel]);

	// useEffect(() => {
	// 	if (officeSlug) {
	// 		requestOffice({ officeSlug });
	// 		requestLines({ officeSlug });
	// 	}
	// }, [officeSlug, requestLines, requestOffice]);

	return { join };
};
